/**
 * The browser's IANA zone, for turns that end up scheduling something.
 *
 * Sent on every turn because the agent decides mid-turn whether it needs one,
 * and there is no way to ask for it afterwards. The server cannot infer it, so
 * without this a schedule is either refused or fires at the wrong hour.
 */
function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null
  } catch {
    return null
  }
}

function refinementRequest(refinement) {
  const selectedText = String(refinement?.selectedText ?? '').trim()
  if (!selectedText) return null

  return {
    selected_text: selectedText,
    source: refinement.source === 'artifact' ? 'artifact' : 'assistant_response',
    ...(refinement.sourceResponseText ? { source_response_text: String(refinement.sourceResponseText) } : {}),
    ...(refinement.artifactId ? { artifact_id: String(refinement.artifactId) } : {}),
    ...(refinement.artifactName ? { artifact_name: String(refinement.artifactName) } : {}),
    ...(refinement.artifactKind ? { artifact_kind: String(refinement.artifactKind) } : {}),
  }
}

export function chatStreamRequestBody(params) {
  const timezone = params.timezone ?? browserTimezone()
  const refinement = refinementRequest(params.refinement)
  return JSON.stringify({
    conversation_id: params.conversationId,
    content: params.content,
    ...(timezone ? { timezone } : {}),
    ...(params.messages?.length ? { messages: params.messages } : {}),
    ...(params.docScope?.length ? { doc_scope: params.docScope } : {}),
    ...(params.attachments?.length ? { attachments: params.attachments } : {}),
    ...(params.proposalId ? { proposal_id: params.proposalId } : {}),
    ...(params.researchMode === 'required' ? { research_mode: 'required' } : {}),
    ...(refinement ? { refinement } : {}),
    ...(params.model && params.model !== 'auto' ? { model: params.model } : {}),
  })
}

import { getActiveWorkspaceId } from '@/store/workspaceStore.js'

export function chatStreamHeaders({ token, headerName, headerPrefix }) {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'text/event-stream',
  }
  if (token) headers[headerName] = `${headerPrefix}${token}`
  const workspaceId = getActiveWorkspaceId()
  if (workspaceId) headers['X-Workspace-Id'] = workspaceId
  return headers
}
